export default "__VITE_PUBLIC_ASSET__7f71e29a__"